// extracted by mini-css-extract-plugin
export default {"newCardWrap":"PaymentModal_newCardWrap__ViT3f","content":"PaymentModal_content__-+sTI"};